export default __webpack_public_path__ + "a0437368ed8500ed4a52b7899134f869.png";